/** @jsx jsx */
import { jsx } from 'theme-ui'
import React, { useContext, useEffect, useState } from 'react'
import { navigate } from 'gatsby'

import { StoreContext } from '~/shopify/ContextProvider'
import AccordionArrow from '~/icons/accordionArrow'
import LineItem from '~/components/LineItem'

export const toggleCart = () => {
  const cart = document.querySelector('.js-cart')
  cart.classList.toggle('is-visible')
  const cartOverlay = document.querySelector('.js-cart-overlay')
  cartOverlay.classList.toggle('is-visible')
}

export const openCart = () => {
  const cart = document.querySelector('.js-cart')
  cart.classList.add('is-visible')
  const cartOverlay = document.querySelector('.js-cart-overlay')
  cartOverlay.classList.add('is-visible')
}

export const closeCart = () => {
  const cart = document.querySelector('.js-cart')
  cart.classList.remove('is-visible')
  const cartOverlay = document.querySelector('.js-cart-overlay')
  cartOverlay.classList.remove('is-visible')
}

function Cart() {
  const { checkout, loading } = useContext(StoreContext)
  const context = useContext(StoreContext)

  const useQuantity = () => {
    const items = checkout ? checkout.lineItems : []
    const total = items.reduce((acc, item) => acc + item.quantity, 0)
    return [total !== 0, total]
  }

  const handleCheckout = () => {
    const url = checkout.webUrl.replace(
      'c1e62e-ad.myshopify.com',
      'shop.planque.co.uk'
    )
    navigate(url)
  }

  const [hasItems, quantity] = useQuantity()

  useEffect(() => {
    const cartToggle = document.querySelector('.js-cart-toggle')

    cartToggle.addEventListener('click', toggleCart)

    return () => {
      cartToggle.removeEventListener('click', toggleCart)
    }
  }, [checkout])

  return (
    <>
      <div
        className="js-cart-overlay"
        onClick={() => {
          closeCart()
        }}
        sx={{
          position: 'fixed',
          inset: 0,
          zIndex: 3,
          opacity: 0,
          visibility: 'hidden',
          cursor: 'pointer',
          '&.is-visible': {
            opacity: 1,
            visibility: 'visible'
          }
        }}
      ></div>
      <div
        className="js-cart"
        sx={{
          position: 'fixed',
          top: 0,
          right: 0,
          width: '100%',
          maxWidth: ['100%', 380],
          background: 'beige',
          height: ['calc(100dvh - 55px)', '100dvh'],
          zIndex: [3, 3],
          transition: 'all 500ms cubic-bezier(0.075, 0.82, 0.165, 1)',
          transform: ['translateY(calc(-100%))', 'translateX(100%)'],
          '&.is-visible': {
            transform: ['translateY(0)', 'translateX(0)'],
            zIndex: [5, 3],
            '.mobile-arrow': {
              transform: 'rotate(180deg)'
            }
          }
        }}
      >
        <div
          className="js-cart-toggle"
          sx={{
            height: [55, '100dvh'],
            position: 'absolute',
            boxShadow: ['0 -1px 0 0 #000000', '1px 0 0 0 #000000'],
            width: ['100%', 55],
            top: ['auto', 0],
            bottom: [-55, 'auto'],
            left: [0, -55],
            background: 'beige',
            px: [25, 0],
            display: 'flex',
            alignItems: 'center',
            borderLeft: ['none', '1px solid black'],
            borderBottom: ['1px solid black', 'none'],
            cursor: 'pointer',
            transitionDelay: '200ms'
          }}
        >
          <div
            sx={{
              position: 'absolute',
              bottom: 0,
              left: 16,
              transform: 'rotate(-90deg)',
              transformOrigin: '0 0',
              display: ['none', 'inline-flex'],
              alignItems: 'center'
            }}
          >
            <AccordionArrow
              className="arrow"
              style={{
                marginRight: 20,
                transition: 'all 500ms cubic-bezier(0.075, 0.82, 0.165, 1)'
              }}
              fill="currentColor"
            />
            <span
              sx={{
                transition: 'all 500ms cubic-bezier(0.075, 0.82, 0.165, 1)',
                letterSpacing: 0,
                fontFamily: 'heading',
                fontSize: 30,
                whiteSpace: 'pre'
              }}
            >
              Cart {checkout.id && `(${quantity})`}
            </span>
          </div>
          <svg
            width="14"
            height="6"
            viewBox="0 0 14 6"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="mobile-arrow"
            sx={{
              display: ['inline-flex', 'inline-flex', 'none']
            }}
          >
            <path d="M0.5 0.5L7 4.5L13.5 0.5" stroke="currentColor" />
          </svg>
          <span
            sx={{
              fontFamily: 'heading',
              marginLeft: 20,
              fontSize: 21,
              marginTop: 1,
              letterSpacing: 0,
              whiteSpace: 'pre',
              display: ['inline-flex', 'inline-flex', 'none']
            }}
          >
            Cart {checkout.id && `(${quantity})`}
          </span>
        </div>
        <div
          sx={{
            display: 'flex',
            flexWrap: 'wrap',
            height: '100%',
            flexDirection: 'column',
            flex: 1
          }}
        >
          {!hasItems ? (
            <div
              sx={{
                width: '100%',
                height: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                textAlign: 'center'
              }}
            >
              <div>
                <h2 sx={{ fontFamily: 'heading', fontSize: 28, mb: 10 }}>
                  Your cart is empty
                </h2>
                <button
                  className="button button--s"
                  onClick={() => closeCart()}
                >
                  continue shopping
                </button>
              </div>
            </div>
          ) : (
            <div sx={{ flex: 2, width: '100%', padding: 20 }}>
              {checkout.lineItems.map((item, i) => {
                return (
                  <LineItem item={item} key={`${item.id}-${item.quantity}`} />
                )
              })}
            </div>
          )}

          {hasItems && (
            <div sx={{ width: '100%', p: 20 }}>
              <div
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  fontFamily: 'heading',
                  mb: 10,
                  fontSize: 24
                }}
              >
                <div>subtotal</div>
                <div>
                  £
                  {checkout.totalPrice.amount
                    .replace('.00', '')
                    .replace('.0', '')}
                </div>
              </div>
              <button
                onClick={handleCheckout}
                disabled={checkout.lineItems.length === 0}
                className="button"
                sx={{
                  width: '100%',
                  bg: 'black !important',
                  color: 'white !important',
                  justifyContent: 'center',
                  '&:hover': {
                    opacity: 0.8
                  }
                }}
              >
                Checkout
              </button>
            </div>
          )}
        </div>
      </div>
    </>
  )
}

export default Cart
